<template>
  <div class="quota-calculator">
    <div class="top">
      <div class="main-title"><span>配额计算器</span></div>
    </div>
    <div class="main-body">
      <div class="sub-title-img"><span>数据填报</span></div>
      <div>
        <p class="body-title">基本信息</p>
        <div class="popup-group">
          <div>
            <van-cell title="行业" :value="from.industry" :is-link="isLinkIndustry" @click="showIndustry"
                      class="popup-style"/>
            <van-popup v-model="isShowIndustry" position="bottom" :style="{ height: '40%' }">
              <van-area title="行业" :area-list="industryList" @confirm="confirmIndustry" @cancel="cancel"
                        columns-num="1"/>
            </van-popup>
          </div>
          <div>
            <van-cell title="地区" :value="from.addr" :is-link="isLinkAddr" @click="showAddr" class="popup-style"/>
            <van-popup v-model="isShowAddr" position="bottom" :style="{ height: '40%' }">
              <van-area title="地区" :area-list="areaList" @confirm="confirmAddr" @cancel="cancel" columns-num="1"/>
            </van-popup>
          </div>
        </div>
      </div>
      <div v-show="isShowElectricity">
        <div class="body-title">机组类型</div>
        <div>
          <van-radio-group v-model="unitType">
            <van-radio name="0" class="unitTypeBtn" @click="showFireCoal">{{ unitTypeList[0].name }}</van-radio>
            <van-radio name="1" class="unitTypeBtn" @click="showFireCoal">{{ unitTypeList[1].name }}</van-radio>
            <van-radio name="2" class="unitTypeBtn" @click="showFireCoal">{{ unitTypeList[2].name }}</van-radio>
            <van-radio name="3" class="unitTypeBtn" @click="showFireGas">{{ unitTypeList[3].name }}</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div v-show="isShowFireCoal">
        <div class="body-title">冷却方式</div>
        <van-radio-group v-model="coolType">
          <van-radio name="0" class="unitTypeBtn">水冷</van-radio>
          <van-radio name="1" class="unitTypeBtn">空冷</van-radio>
        </van-radio-group>
        <ul v-for="(stage,index) in title" :key="index">
          <li class="body-title">{{ stage }}</li>
          <van-cell-group class="input-group">
            <van-field class="input"
                       v-for="(item,key) in fireCoalInput[index]"
                       :key="key"
                       v-model="item.value"
                       :label="item.label"
                       :placeholder="item.placeholder"
                       type="number"/>
          </van-cell-group>
        </ul>
      </div>
      <div v-show="isShowFireGas">
        <ul v-for="(stage,index) in title" :key="index">
          <li class="body-title">{{ stage }}</li>
          <van-cell-group class="input-group">
            <van-field class="input"
                       v-for="(item,key) in fireGasInput[index]"
                       :key="key"
                       v-model="item.value"
                       :label="item.label"
                       :placeholder="item.placeholder"
                       type="number"/>
          </van-cell-group>
        </ul>
      </div>
      <div class="btn-block">
        <button class="btn-next" @click="next">计算配额</button>
      </div>
      <div v-show="isShowResult" style="margin-top: 15px">
        <div class="sub-title-img"><span>配额总览</span></div>
        <div class="emission-top-view">
          <div class="digit-view">
            <p class="digit-title">供电配额
              <img src="../assets/images/tip.png" @click="showPowerTip" height="10" v-show="false">
            </p>
            <van-popup v-model="isShowPowerTip" round style="height: 25%;width: 80%">
              <p class="emission-level-tip" style="font-weight: bold">xxxx</p>
              <p class="emission-level-tip">......</p>
            </van-popup>
            <p class="total-emission">{{ powerSupplyQuota }}</p>
            <p class="unit">吨CO2</p>
          </div>
          <div class="digit-view">
            <p class="digit-title">供热配额
              <img src="../assets/images/tip.png" @click="showHeatTip" height="10" style="margin-left: -3px"
                   v-show="false">
            </p>
            <van-popup v-model="isShowHeatTip" round style="height: 20%;width: 80%">
              <p class="emission-level-tip" style="font-weight: bold">xxx</p>
              <p class="emission-level-tip">....</p>
            </van-popup>
            <p class="total-emission">{{ heatSupplyQuota }}</p>
            <p class="unit">吨CO2</p>
          </div>
          <div class="digit-view">
            <p class="digit-title">总配额
              <img src="../assets/images/tip.png" @click="showTotalTip" height="10" v-show="false">
            </p>
            <van-popup v-model="isShowTotalTip" round style="height: 32%;width: 80%">
              <p class="emission-level-tip" style="font-weight: bold">xxx</p>
              <p class="emission-level-tip">.....</p>
            </van-popup>
            <p class="emission-level">{{ totalQuota }}</p>
            <p class="unit">吨CO2</p>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 20px"></div>
  </div>
</template>

<script>
import { quotaAreaList } from '../assets/js/quotaAreaList'
import { quotaIndustry } from '../assets/js/quotaIndustry'
import { Toast } from 'vant'

export default {
  name: 'Home',
  data () {
    return {
      isShowIndustry: false,
      isShowAddr: false,
      isLinkIndustry: true,
      isLinkAddr: true,
      isShowElectricity: false, // 是否显示电力行业的输入框
      isShowFireCoal: false, // 是否显示燃煤机组
      isShowFireGas: false, // 是否显示燃气机组
      isShowPowerTip: false, // 是否显示问号提示框
      isShowHeatTip: false,
      isShowTotalTip: false,
      isShowResult: false, // 是否显示结果
      industryNo: 0,
      powerSupplyQuota: 0, // 发电配额
      heatSupplyQuota: 0, // 发热配额
      totalQuota: 0, // 总配额
      areaList: quotaAreaList,
      industryList: quotaIndustry,
      from: {
        industry: '请选择行业',
        addr: '请选择地区'
      },
      coolType: '',
      unitType: '',
      title: ['供电配额量计算', '供热配额量计算'],
      coolTypeFactor: [1, 1.05],
      unitTypeList: [
        {
          name: '300MW等级以上常规燃煤机组',
          powerSupplyRefVal: '0.877',
          heatSupplyRefVal: '0.126'
        },
        {
          name: '300MW等级以下常规燃煤机组',
          powerSupplyRefVal: '0.979',
          heatSupplyRefVal: '0.126'
        },
        {
          name: '非常规燃煤机组',
          powerSupplyRefVal: '1.146',
          heatSupplyRefVal: '0.126'
        },
        {
          name: '燃气机组',
          powerSupplyRefVal: '0.392',
          heatSupplyRefVal: '0.059'
        }
      ],
      fireCoalInput: [
        [
          {
            value: '',
            label: '机组供电量',
            placeholder: '单位：MWh'
          },
          {
            value: '',
            label: '机组负荷系数',
            placeholder: '请输入一个小数'
          },
          {
            value: '',
            label: '供热比',
            placeholder: '请输入一个小数'
          }
        ],
        [
          {
            value: '',
            label: '机组供热量',
            placeholder: '单位：GJ'
          }
        ]
      ],
      fireGasInput: [
        [
          {
            value: '',
            label: '机组供电量',
            placeholder: '单位：MWh'
          },
          {
            value: '',
            label: '供热比',
            placeholder: '请输入一个小数'
          }
        ],
        [
          {
            value: '',
            label: '机组供热量',
            placeholder: '单位：GJ'
          }
        ]
      ]
    }
  },
  methods: {
    next () {
      // 判断输入参数是否为空
      if (this.isLinkIndustry === true) {
        Toast('请选择行业')
      } else if (this.unitType === '') {
        Toast('请选择机组类型')
      } else {
        let powerSupplyQuota = 0
        let heatSupplyQuota = 0
        if (this.isShowFireCoal) {
          if (this.coolType === '') {
            Toast('请选择冷却方式')
          } else if (this.fireCoalInput[0][0].value === '') {
            Toast('请输入机组供电量')
          } else if (this.fireCoalInput[0][1].value === '') {
            Toast('请输入机组负荷系数')
          } else if (this.fireCoalInput[0][2].value === '') {
            Toast('请输入供热比')
          } else if (this.fireCoalInput[0][1].value > 1 || this.fireCoalInput[0][1].value < 0) {
            Toast('机组负荷系数输入数值有误')
          } else if (this.fireCoalInput[0][2].value > 1 || this.fireCoalInput[0][2].value < 0) {
            Toast('供热比输入数值有误')
          } else {
            // 供电配额量 = 机组供电量*机组所属类别的供电基准值*机组冷却方式修正系数*机组供热量修正系数*机组负荷（出力）系数修正系数
            console.log(this.unitType)
            console.log(this.coolType)
            let valF = this.fireCoalInput[0][1].value
            let correctionFactor = 0 // 机组负荷（出力）系数修正系数
            if (valF >= 0.85) {
              correctionFactor = 1
            } else if (valF >= 0.80 && valF < 0.85) {
              correctionFactor = 1 + 0.0014 * (85 - 100 * valF)
            } else if (valF >= 0.75 && valF < 0.80) {
              correctionFactor = 1.007 + 0.0016 * (80 - 100 * valF)
            } else {
              correctionFactor = Math.pow(1.015, 16 - 20 * valF)
            }
            console.log('机组负荷（出力）系数修正系数' + correctionFactor)
            powerSupplyQuota = this.fireCoalInput[0][0].value * this.unitTypeList[this.unitType].powerSupplyRefVal *
              this.coolTypeFactor[this.coolType] * (1 - 0.22 * this.fireCoalInput[0][2].value) * correctionFactor
            heatSupplyQuota = this.fireCoalInput[1][0].value * this.unitTypeList[this.unitType].heatSupplyRefVal
            this.powerSupplyQuota = powerSupplyQuota.toFixed(3)
            this.heatSupplyQuota = heatSupplyQuota.toFixed(3)
            this.totalQuota = (powerSupplyQuota + heatSupplyQuota).toFixed(3)
            this.isShowResult = true
          }
        } else {
          if (this.fireGasInput[0][0].value === '') {
            Toast('请输入机组供电量')
          } else if (this.fireCoalInput[0][1].value === '') {
            Toast('请输入供热比')
          } else if (this.fireCoalInput[0][1].value > 1 || this.fireCoalInput[0][1].value < 0) {
            Toast('供热比输入数值有误')
          } else {
            // 供热配额量 = 机组供电量*机组所属类别的供电基准值*机组供热量修正系数（1-0.6× 供热比）
            powerSupplyQuota = this.fireGasInput[0][0].value * this.unitTypeList[this.unitType].powerSupplyRefVal *
              (1 - 0.6 * this.fireGasInput[0][1].value)
            heatSupplyQuota = this.fireGasInput[1][0].value * this.unitTypeList[this.unitType].heatSupplyRefVal
            this.powerSupplyQuota = powerSupplyQuota.toFixed(3)
            this.heatSupplyQuota = heatSupplyQuota.toFixed(3)
            this.totalQuota = (powerSupplyQuota + heatSupplyQuota).toFixed(3)
            this.isShowResult = true
          }
        }
        console.log(this.powerSupplyQuota)
        console.log(this.heatSupplyQuota)
      }
    },
    showIndustry () {
      this.isShowIndustry = true
    },
    showAddr () {
      this.isShowAddr = true
    },
    cancel () {
      this.isShowAddr = false
      this.isShowIndustry = false
    },
    showFireCoal () {
      this.isShowFireCoal = true
      this.isShowFireGas = false
      this.isShowResult = false
    },
    showFireGas () {
      this.isShowFireCoal = false
      this.isShowFireGas = true
      this.isShowResult = false
    },
    showPowerTip () {
      this.isShowPowerTip = true
    },
    showHeatTip () {
      this.isShowHeatTip = true
    },
    showTotalTip () {
      this.isShowTotalTip = true
    },
    confirmIndustry (val) {
      this.from.industry = ''
      val.forEach((element) => {
        let industry = element.name
        if (this.from.industry.indexOf(industry) === -1) {
          this.from.industry = industry
          console.log(element.code)
          let industryNo = ((element.code / 10000) - 10).toFixed(0)
          // code为行业编号，industryNo为行业在industryList中的下标
          this.industryNo = industryNo
          console.log('行业编号为：' + this.industryNo)
          if (industryNo === '1') {
            this.isShowElectricity = true
          } else {
            this.isShowElectricity = false
          }
        }
      })
      // 选泽行业后把弹出框和箭头取消
      this.isShowIndustry = false
      this.isLinkIndustry = false
    },
    confirmAddr (val) {
      this.from.addr = ''
      val.forEach((element) => {
        if (this.from.addr.indexOf(element.name) === -1) {
          this.from.addr = this.from.addr + element.name
        }
      })
      // 选泽地区后把弹出框和箭头取消
      this.isShowAddr = false
      this.isLinkAddr = false
    }
  }
}
</script>
<style lang="scss" scoped>
.quota-calculator {
  height: 100%;
  background-image: url("../assets/images/bg.png");
  background-size: 100%;
}

.unitTypeBtn {
  margin: 10px 0px 10px 20px;
  font-size: 14px;
  color: #333333;
}

.main-body {
  .sub-title-img {
    width: 106px;
    height: 30px;
    line-height: 30px;
    background-image: url("../assets/images/title_bg.png");
    margin-bottom: 15px;

    span {
      margin-left: 15px;
      font-size: 16px;
      color: #ffffff;
    }
  }

  .popup-style {
    border-radius: 10px 10px 0px 0px;
  }

  .popup-group {
    margin: 15px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);
    border-radius: 10px;
  }

  .input-group {
    margin: 15px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);
    border-radius: 10px;
    opacity: 0.9;
  }

  .input {
    width: auto;
    border-radius: 10px;
    font-size: 14px;
    color: #666666;
  }

  .btn-block {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 24px;

    button {
      width: 100%;
      height: 40px;
      margin: 0px 15px 5px 15px;
      font-size: 18px;
      color: #ffffff;
      background-color: #2161ff;
      border-radius: 40px;
    }
  }
}

.emission-level-tip {
  font-size: 18px;
  margin: 20px;
  line-height: 30px;
}

.emission-top-view {
  display: flex;
  justify-content: center;

  .digit-view {
    width: 103px;
    height: 103px;
    background-color: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(13, 111, 200, 0.26);
    border-radius: 10px 0px 15px 0px;
    text-align: center;
    margin: 0px 11px 0px 11px;

    .total-emission {
      font-size: 18px;
      font-weight: bold;
      line-height: 6px;
      color: #2161ff;
    }

    .emission-level {
      font-size: 18px;
      font-weight: bold;
      line-height: 6px;
      color: #f24242;
    }
  }
}

.digit-title {
  font-weight: bold;
  font-size: 13px;
  color: #333333;
}

.unit {
  font-size: 11px;
  line-height: 6px;
  color: #999999;
}
</style>
